import { render, staticRenderFns } from "./TreasureListView.vue?vue&type=template&id=03454a76&scoped=true"
import script from "./TreasureListView.vue?vue&type=script&lang=js"
export * from "./TreasureListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03454a76",
  null
  
)

export default component.exports